import ClassicEditor from "ckeditor5-build-classic-plus";
export default {
    editor: ClassicEditor,
    editorConfig: {
        licenseKey: process.env.VUE_APP_CKEDITOR_LICENSE_KEY || "GPL",
        toolbar: {
            items: [
                "heading",
                "|",
                "fontSize",
                "fontFamily",
                "|",
                "fontColor",
                "fontBackgroundColor",
                "|",
                "bold",
                "italic",
                "link",
                "bulletedList",
                "numberedList",
                "blockQuote",
                "undo",
                "redo",
                "highlight",
            ],
        },
        highlight: {
            options: [
                {
                    model: "greenMarker",
                    class: "marker-green",
                    title: "Green marker",
                    color: "var(--ck-content-highlight-marker-green)",
                    type: "marker",
                },
                {
                    model: "redPen",
                    class: "pen-red",
                    title: "Red pen",
                    color: "var(--ck-content-highlight-pen-red)",
                    type: "pen",
                },
            ],
        },
    },
};
